const IconInstagram = (): JSX.Element => {
  return (
    <>
      <g>
        <path
          d="M16.7,2c3,0,5.4,2.4,5.4,5.4v9.3c0,3-2.4,5.4-5.4,5.4H7.3c-3,0-5.4-2.4-5.4-5.4V7.3C2,4.4,4.4,2,7.3,2h9.3M16.7,0H7.3C3.3,0,0,3.3,0,7.3v9.3c0,4.1,3.3,7.3,7.3,7.3h9.3c4.1,0,7.3-3.3,7.3-7.3V7.3c0-4.1-3.3-7.3-7.3-7.3Z"
          fill="currentColor"
        />
        <path
          d="M18.4,4.2c-.8,0-1.4.6-1.4,1.4s.6,1.4,1.4,1.4c.8,0,1.4-.6,1.4-1.4s-.6-1.4-1.4-1.4h0Z"
          fill="currentColor"
        />
        <path
          d="M12.1,7.7c2.4,0,4.3,1.9,4.3,4.3,0,2.4-1.9,4.3-4.3,4.3-2.4,0-4.3-1.9-4.3-4.3,0,0,0,0,0,0,0-2.4,1.9-4.3,4.3-4.3M12.1,5.7c-3.5,0-6.3,2.8-6.3,6.3,0,3.5,2.8,6.3,6.3,6.3,3.5,0,6.3-2.8,6.3-6.3,0-3.5-2.8-6.3-6.3-6.3,0,0,0,0,0,0Z"
          fill="currentColor"
        />
      </g>
    </>
  );
};

export default IconInstagram;
